import { Tab, Tabs } from '@mui/material'
import { Link } from 'react-router-dom'

export const LocationSweepstakeDetailsTabs = ({
  currentTab,
  sweepstakeId,
}: {
  currentTab: any
  sweepstakeId: number
}) => {
  return (
    <Tabs value={currentTab}>
      <Tab
        label="Overview"
        value={`/Contests/LocationSweepstakes/${sweepstakeId}/Overview`}
        to={`/Contests/LocationSweepstakes/${sweepstakeId}/Overview`}
        component={Link}
      />
      <Tab
        label="Participating Locations"
        value={`/Contests/LocationSweepstakes/${sweepstakeId}/ParticipatingLocations`}
        to={`/Contests/LocationSweepstakes/${sweepstakeId}/ParticipatingLocations`}
        component={Link}
      />
      <Tab
        label="Winners"
        value={`/Contests/LocationSweepstakes/${sweepstakeId}/Winners`}
        to={`/Contests/LocationSweepstakes/${sweepstakeId}/Winners`}
        component={Link}
      />
      <Tab
        label="Settings"
        value={`/Contests/LocationSweepstakes/${sweepstakeId}/Settings`}
        to={`/Contests/LocationSweepstakes/${sweepstakeId}/Settings`}
        component={Link}
      />
    </Tabs>
  )
}
